import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// New Editorial Pages
import EditorialHomePage from "./pages/EditorialHomePage";
import MentorshipPage from "./pages/MentorshipPage";

// Legacy/Preview Pages
import ComingSoonPage from "./pages/ComingSoonPage";
import Home from "./pages/Home";
import DWAPage from "./pages/DWAPage";
import ThemeSamples from "./pages/ThemeSamples";
import ContactPage from "./pages/ContactPage";
import AdminEmailsPage from "./pages/AdminEmailsPage";
import FunnelPage from "./pages/FunnelPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main Editorial Site */}
          <Route path="/" element={<EditorialHomePage />} />
          <Route path="/mentorship" element={<MentorshipPage />} />
          <Route path="/resources" element={<EditorialHomePage />} />
          <Route path="/success-stories" element={<EditorialHomePage />} />
          <Route path="/journal" element={<EditorialHomePage />} />
          
          {/* Coming Soon (preserved) */}
          <Route path="/coming-soon" element={<ComingSoonPage />} />
          
          {/* Preview/Edit Routes - Full site accessible for editing */}
          <Route path="/preview" element={<Home />} />
          <Route path="/preview/dwa" element={<DWAPage />} />
          <Route path="/preview/contact" element={<ContactPage />} />
          <Route path="/preview/funnel" element={<FunnelPage />} />
          
          {/* Admin & Utility Routes */}
          <Route path="/admin/emails" element={<AdminEmailsPage />} />
          <Route path="/samples" element={<ThemeSamples />} />
          
          {/* Legacy routes */}
          <Route path="/dwa" element={<DWAPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/free-training" element={<FunnelPage />} />
          <Route path="/funnel" element={<FunnelPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
